import { NEW_ITEM_DEFAULT_LABEL } from './utils'

let tempIdCounter = 0

export const nextTempRowId = () => {
    tempIdCounter += 1
    return `master-new-${Date.now()}-${tempIdCounter}`
}

export const isNewMasterRow = id => String(id).startsWith('master-new-')

export const masterItemToEditorRow = (item, index) => ({
    Id: item.id,
    DisplayText: item.displayText || '',
    BackColorCode: item.backColorCode || '#808080',
    ForeColorCode: item.foreColorCode || '#FFFFFF',
    Score:
        item.isScoreFromQuestion ? '' : item.score ?? '',
    AllowManualScore: !!item.allowManualScore,
    MaxManualScore: Number(item.maxManualScore) || 0,
    IsScoreOnThisResponse: !!item.isScoreFromQuestion,
    IsExcludedFromScoring: !!item.isExcludedFromScoring,
    DisplayOrder: item.displayOrder ?? index,
    Hints: item.helpText
        ? [{ Heading: '', HintText: item.helpText, MediaPath: '' }]
        : [],
    _isNew: isNewMasterRow(item.id),
    _deleted: false,
})

export const emptyEditorRow = (displayOrder = 0) => ({
    Id: nextTempRowId(),
    DisplayText: '',
    BackColorCode: '#808080',
    ForeColorCode: '#FFFFFF',
    Score: '',
    AllowManualScore: false,
    MaxManualScore: 0,
    IsScoreOnThisResponse: false,
    IsExcludedFromScoring: false,
    DisplayOrder: displayOrder,
    Hints: [],
    _isNew: true,
    _deleted: false,
})

export const editorRowToApiPayload = (row, displayOrder) => {
    const displayText = (row.DisplayText || '').trim()
    if (!displayText) return null

    const hint = row.Hints?.[0]
    const helpText = hint
        ? [hint.Heading, hint.HintText]
              .map(s => (s || '').trim())
              .filter(Boolean)
              .join('\n')
        : (row.HelpText || '').trim()

    const payload = {
        DisplayText: displayText,
        Score: row.IsScoreOnThisResponse
            ? null
            : Number(row.Score) || 0,
        DisplayOrder: displayOrder,
        BackColorCode: row.BackColorCode || '',
        ForeColorCode: row.ForeColorCode || '',
        HelpText: helpText || '',
        IsScoreFromQuestion: !!row.IsScoreOnThisResponse,
        IsExcludedFromScoring: !!row.IsExcludedFromScoring,
        AllowManualScore: !!row.AllowManualScore,
        MaxManualScore: row.AllowManualScore
            ? Number(row.MaxManualScore) || 0
            : null,
    }

    const mediaPath =
        hint?.MediaPath?.trim() ||
        hintFilesUrl(row) ||
        ''
    if (mediaPath) {
        payload.HelpTextMediaPath = mediaPath
    }

    return payload
}

const hintFilesUrl = row => {
    const path = row.Hints?.[0]?.MediaPath
    return path && String(path).trim() ? path : ''
}

export const excelRowsFromValues = values =>
    values
        .map((value, idx) => ({
            Id: nextTempRowId(),
            DisplayText: String(value).trim(),
            BackColorCode: '#808080',
            ForeColorCode: '#FFFFFF',
            Score: '',
            AllowManualScore: false,
            MaxManualScore: 0,
            IsScoreOnThisResponse: false,
            IsExcludedFromScoring: false,
            DisplayOrder: idx,
            Hints: [],
            _isNew: true,
            _deleted: false,
        }))
        .filter(r => r.DisplayText)

export const defaultRowForCreate = () => ({
    ...emptyEditorRow(0),
    DisplayText: NEW_ITEM_DEFAULT_LABEL,
})
